<template>
    <div>
        <div class="page-platformList">
            <v-container>
                <div class="page-platformList__title">
                    <i class="icon-icon-providers"></i>
                    <div class="text">
                        <h1>{{ $t('front.provider.page.title') }}</h1>
                        <p>{{ $t('front.provider.page.description') }}</p>
                    </div>
                </div>
                <div class="page-platformList__list">
                    <div class="item" v-for="(item, index) in platforms" :key="index">
                        <div class="item__box">
                            <div class="item__image">
                                <router-link :to="item.pageUrl">
                                    <picture>
                                        <source :srcset="item.logo[sourceType]" :type="`image/${sourceType}`"
                                                v-for="(sourceType, index) in item.logo.sourcesTypes" :key="index">
                                        <img :src="item.logo.jpg" :alt="item.title"/>
                                    </picture>
                                </router-link>
                            </div>
                            <div class="item__content">
                                <div class="item__content-inf">
                                    <h2 v-text="item.title"/>
                                    <div class="rate">
                                        <img :src="itemRatingImage(item, index)" alt="rating" v-for="index in 5">
                                    </div>
                                </div>
                                <router-link class="read-btn" :to="item.pageUrl">
                                    {{ $t('front.provider.button.read_more') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-platformList__load" v-if="hasMorePlatforms">
                    <v-btn :loading="morePlatformsLoading" @click="showMorePlatforms">{{ $t('front.provider.button.load_more') }}</v-btn>
                </div>
            </v-container>
        </div>

    </div>
</template>

<script>
import apiData from "../../../../../../../src/mixins/apiData";

export default {
    name: "PlatformsItems",

    mixins: [apiData],

    data: function () {
        return {
            morePlatformsLoading: false,
        }
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        platformsData(){
            return this.$store.state.gamePlatformsData;
        },

        platforms() {
            return this.platformsData && this.platformsData.platforms || [];
        },

        hasMorePlatforms() {
            return this.platformsData && this.platformsData.hasMorePlatforms;
        },
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_GAME_PLATFORMS', this.createApiData({
                count: 8,
                offset: 0,
            }));
        },

        itemRatingImage(item, index){
            if (item.rating >= index){
                return '../../../../../public/icons/star-yes-tusk.svg';
            }else {
                return '../../../../../public/icons/star-no-tusk.svg';
            }
        },

        showMorePlatforms(){
            if (this.morePlatformsLoading) {
                return;
            }

            this.morePlatformsLoading = true;

            this.$store.dispatch('FETCH_GAME_PLATFORMS', this.createApiData({
                count: 8,
                offset: this.platforms.length,
                loadMore: true,
            }))
                .then(() => this.morePlatformsLoading = false)
                .catch(() => this.morePlatformsLoading = false);
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/target/PlatformsItems"
</style>